<template>
    <vue-custom-scrollbar>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Тип продукта <span class="red-text">*</span>
            </div>
            <select class="cd-modal-text-input" v-model="type">
                <option disabled selected value="">- Не выбрано -</option>
                <option value="wall">Фасад</option>
                <option value="additional">Доборный элемент</option>
<!--                <option value="platband">Наличник</option>-->
            </select>
            <div class="form-alert-danger" v-show="showAlert === 'type'">
                Обязательное поле!
            </div>
            <div class="margin-20-0" v-show="!type">
                <i>Сперва укажите тип продукта, который Вы бы хотели добавить.</i>
            </div>
        </div>
        <div class="ap-product-modal-grid" v-show="type">
            <div>
                <div class="ap-modal-element">
                    <div class="ap-modal-input-name">
                        Название продукта <span class="red-text">*</span>
                    </div>
                    <input type="text" class="cd-modal-text-input" v-model="name">
                    <div class="form-alert-danger" v-show="showAlert === 'name'">
                        Обязательное поле!
                    </div>
                    <div class="ap-modal-input-name">
                        Артикул <span class="red-text">*</span>
                    </div>
                    <input type="text" class="cd-modal-text-input" v-model="vendorCode">
                    <div class="form-alert-danger" v-show="showAlert === 'vendor_code'">
                        Обязательное поле!
                    </div>
                </div>
                <div class="ap-modal-title-medium">
                    Параметры текстуры
                </div>
                <div class="ap-modal-element" v-show="type === 'wall'">
                    <div class="ap-modal-input-name">
                        Высота текстуры, м (не более 15)
                    </div>
                    <input type="number" min="0" max="15" step="0.1" class="cd-modal-text-input" v-model="textureHeight">
                    <div class="form-alert-danger" v-show="showDimensionsAlert === 'textureHeight'">
                        Недопустимо высокое значение!
                    </div>
                </div>
                <div class="ap-modal-element">
                    <div class="ap-modal-input-name">
                        <span v-show="type === 'wall'">Ширина текстуры, м (не более 15)</span>
                        <span v-show="type !== 'wall'">Ширина продукта, м (не более 15)</span>
                    </div>
                    <input type="number" min="0" max="15" step="0.1" class="cd-modal-text-input" v-model="textureWidth">
                    <div class="form-alert-danger" v-show="showDimensionsAlert === 'textureWidth'">
                        Недопустимо высокое значение!
                    </div>
                </div>
                <div class="ap-modal-element">
                    <div class="ap-modal-input-name">
                        Цвет
                    </div>
                    <div class="custom-select-grid" v-on:click="showColorDropdown = !showColorDropdown">
                        <div class="cd-modal-text-input custom-select">
                            <div class="custom-select-color-circle-border" :class="{'color-border': color_id !== ''}">
                                <div class="custom-select-color-circle" :style="{'background-color': colorDataByID.hex}"></div>
                            </div>
                            <div>
                                {{colorDataByID.name}}
                            </div>
                        </div>
                        <SVGPallet class="custom-select-switch"/>
                    </div>
                    <vue-custom-scrollbar class="custom-select-dropdown" v-show="showColorDropdown">
                        <div class="custom-select-option" v-for="option in optionsColors" v-on:click="selectColor(option.id)">
                            <div class="custom-select-color-circle-border" style="border-color: #929292">
                                <div class="custom-select-color-circle" :style="{'background-color': option.hex}"></div>
                            </div>
                            <div>
                                {{option.name}}
                            </div>
                        </div>
                    </vue-custom-scrollbar>
                    <div class="form-alert-danger" v-show="showAlert === 'color_id'">
                        Обязательное поле!
                    </div>
                </div>
<!--                <div class="ap-modal-element">-->
<!--                    <div class="ap-modal-input-name">-->
<!--                        Цвет-->
<!--                    </div>-->
<!--                    <select class="cd-modal-text-input" v-model="color_id">-->
<!--                        <option v-for="option in optionsColors" :value="option.id">{{option.name}}</option>-->
<!--                    </select>-->
<!--                    <div class="form-alert-danger" v-show="showAlert === 'color_id'">-->
<!--                        Обязательное поле!-->
<!--                    </div>-->
<!--                </div>-->
                <div class="ap-modal-title-medium">
                    Категория продукта <span class="red-text">*</span>
                </div>
                <div class="ap-button-edit-category ap-modal-element" v-on:click="selectCategory">
                    <SVGAdminEditRow class="ap-button-edit-category-svg"/>
                    <div v-if="getCategoryByIds(categories).name"
                         class="ap-button-edit-category-text">{{getCategoryByIds(categories).name}}</div>
                    <div v-else class="ap-button-edit-category-text">Категория не выбрана</div>
                </div>
                <div class="ap-modal-element" v-show="showAlert === 'categories'">
                    <div class="form-alert-danger">
                        Обязательное поле!
                    </div>
                </div>
            </div>
            <div>
                <div class="ap-modal-element">
                    <div class="ap-modal-input-name">
                        Стоимость, ₽
                    </div>
                    <input type="text" class="cd-modal-text-input" v-model="price">
                    <div class="form-alert-danger" v-show="showAlert === 'price'">
                        Обязательное поле!
                    </div>
                </div>
                <div class="ap-modal-element">
                    <div class="modal-checkbox-grid">
                        <div class="pretty p-default modal-checkbox">
                            <input class="cd-modal-text-input" type="checkbox" v-model="active"/>
                            <div class="state p-danger">
                                <label></label>
                            </div>
                        </div>
                        <div class="modal-checkbox-text">
                            Доступен в конфигураторе
                        </div>
                    </div>
                </div>
                <div v-show="type === 'wall'">
                    <div class="ap-modal-title-medium">
                        Изображение текстуры
                    </div>
                    <div v-show="srcTextureImg" class="ap-change-photo-anchor">
                        <div class="ap-change-photo-btn" @click="$refs.loadTextureImg.click()">
                            <SVGAdminEditRow class=""/>
                        </div>
                    </div>
                    <img v-if="srcTextureImg" alt="texture" class="ap-product-modal-img"
                         :src="urlForPhoto(srcTextureImg)"/>
                    <SVGApLoadProductImg v-else class="ap-product-modal-img pointer" @click.native="$refs.loadTextureImg.click()"/>
                    <input hidden type="file" ref="loadTextureImg"
                           v-on:change="handleFileUpload($event, callbackLoadedTextureImg)" accept=".jpg,.png">
                </div>
                <div class="ap-modal-title-medium">
                    Миниатюра
                </div>
                <div v-show="srcPreviewImg" class="ap-change-photo-anchor">
                    <div class="ap-change-photo-btn" @click="$refs.loadPrevImg.click()">
                        <SVGAdminEditRow class=""/>
                    </div>
                </div>
                <img v-if="srcPreviewImg" alt="texture" class="ap-product-modal-img"
                     :src="urlForPhoto(srcPreviewImg)"/>
                <SVGApLoadProductImg v-else class="ap-product-modal-img pointer" @click.native="$refs.loadPrevImg.click()"/>
                <input hidden type="file" ref="loadPrevImg"
                                       v-on:change="handleFileUpload($event, callbackLoadedPreviewImg)" accept=".jpg,.png">
            </div>
        </div>
        <div class="modal-button" v-on:click="apply">
            {{buttonName}}
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import SVGPhotoDnDLoad from "../../../SVG/SVGPhotoDnDLoad";
    import {bus} from "../../../../vue_bus";
    import ProductCategories from "./ProductCategories";
    import {v4 as uuidv4} from 'uuid';
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import {uploadFirstFile} from "../../../../httpConfig";
    import SVGAdminEditRow from "../../../SVG/SVGAdminEditRow";
    import SVGApLoadProductImg from "../../../SVG/SVGApLoadProductImg";
    import SVGChange from "../../../SVG/SVGChange";
    import SVGPallet from "../../../SVG/SVGPallet";

    export default {
        name: "DataEntryFields",
        components: {
            SVGPallet,
            SVGChange,
            SVGApLoadProductImg,
            SVGAdminEditRow,
            SVGPhotoDnDLoad,
            vueCustomScrollbar
        },
        data() {
            return {
                active: true,
                dragover: false,
                uuid: '',
                name: '',
                type: '',
                color_id: '',
                price: '',
                categories: [],
                organization_id: 888,
                srcPreviewImg: '',
                srcTextureImg: '',
                textureHeight: '',
                textureWidth: '',
                vendorCode: '',
                showDimensionsAlert: '',
                showColorDropdown: false,
                necessaryFields: [
                    'type',
                    'name',
                    'vendor_code',
                    'categories'
                ],
                showAlert: ''
            }
        },
        props: {
            buttonName: {
                type: String,
                default: 'Нет названия'
            },
            dataProduct: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        computed: {
            idJuniorCategory() {
                return [this.categories[this.categories.length - 1]];
            },
            optionsColors() {
                return this.$store.state.adminPanel.colors.colors
            },
            colorDataByID() {
                if (this.color_id) {
                    return this.optionsColors[this.optionsColors.findIndex(color => color.id === this.color_id)]
                } else {
                    return {
                        name: '',
                        hex: ''
                    }
                }
            }
        },
        methods: {
            selectColor(id) {
                this.color_id = id;
                this.showColorDropdown=false;
            },
            getCategoryByIds(ids) {
                return this.$store.getters["adminPanel/categories/CATEGORY_BY_HIERARCHY_IDS"](ids);
            },
            urlForPhoto(url) {
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            },
            callbackLoadedPreviewImg(fileList) {
                this.srcPreviewImg = fileList[0];
            },
            callbackLoadedTextureImg(fileList) {
                this.srcTextureImg = fileList[0];
            },
            handleFileUpload(fileInput, callback) {
                const progress = (progress) => {
                    console.log(progress);
                };

                uploadFirstFile(fileInput, progress)
                    .then((request) => {
                        callback(request.data.fileList);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            checkDimensions(width, height) {
                if (width > 15) {
                    this.showDimensionsAlert = 'textureWidth'
                    return false
                } else if (height > 15) {
                    this.showDimensionsAlert = 'textureHeight'
                    return false
                } else {
                    this.showDimensionsAlert = ''
                    return true
                }

            },
            checkCategories(array){
                for (let value in array) {
                    if (array[value] === undefined) {
                        return false
                    }
                }
                return true
            },
            checkNecessary(data) {
                for (let field in this.necessaryFields) {
                    if (!data[this.necessaryFields[field]]) {
                        return this.necessaryFields[field]
                    } else if (this.necessaryFields[field] === 'categories') {
                        if (!this.checkCategories(data[this.necessaryFields[field]])) {
                            return this.necessaryFields[field];
                        }
                    }
                }
                return true
            },
            apply() {
                let data = {
                    active: this.active,
                    uuid: this.uuid,
                    name: this.name,
                    type: this.type,
                    price: this.price,
                    categories: this.idJuniorCategory,
                    organization_id: this.organization_id,
                    preview: this.srcPreviewImg,
                    texture: this.srcTextureImg,
                    texture_height: this.textureHeight,
                    texture_width: this.textureWidth,
                    color_id: this.color_id,
                    vendor_code: this.vendorCode
                }
                if (this.type !== 'wall') {
                    data.texture = ''
                    data.texture_height = ''
                }
                console.log(data)
                let checkResult = this.checkNecessary(data)
                if (this.checkDimensions(this.textureWidth, this.textureHeight)) {
                    if (checkResult === true) {
                        this.$emit('apply', data);
                    } else {
                        this.showAlert = checkResult
                    }
                }
            },
            selectCategory() {
                const beforeOpen = (event) => {
                    bus.$on('productCategorySelected', (ids) => {
                        this.categories = ids;
                        this.$modal.hide('product-categories');
                    });
                };
                const beforeClose = (event) => {
                    bus.$off('productCategorySelected');
                };

                this.$modal.show(ProductCategories, {}, {
                        height: '70%',
                        pivotY: 0.4,
                        width: 450,
                        draggable: true,
                        name: 'product-categories',
                    },
                    {
                        'before-open': beforeOpen,
                        'before-close': beforeClose
                    });
            }
        },
        async mounted() {
            await this.$store.dispatch('adminPanel/colors/GET_COLORS');
            if (Object.keys(this.dataProduct).length !== 0) {
                this.active = this.dataProduct.active;
                this.name = this.dataProduct.name;
                this.categories = this.dataProduct.hierarchy_ids;
                this.type = this.dataProduct.type;
                this.uuid = this.dataProduct.uuid;
                this.price = this.dataProduct.price;
                this.organization_id = this.dataProduct.organization_id;
                this.srcPreviewImg = this.dataProduct.preview;
                this.srcTextureImg = this.dataProduct.texture;
                this.textureHeight = this.dataProduct.texture_height;
                this.color_id = this.dataProduct.color_id;
                this.textureWidth = this.dataProduct.texture_width;
                this.vendorCode = this.dataProduct.vendor_code;
                console.log(this.dataProduct.preview, this.dataProduct.texture);
            } else {
                this.uuid = uuidv4();
            }
        }
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number] {
        -moz-appearance:textfield;
    }

    .custom-select-grid {
        display: inline-flex;
        width: 100%;
        cursor: default;
    }

    .custom-select {
        min-height: 16px;
        font-size: 14px;
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 20px;
    }

    .custom-select-color-circle-border {
        border: 1px solid white;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .color-border {
        border-color: #ACACAC;
    }

    .custom-select-color-circle {
        border: 1px solid white;
        border-radius: 7px;
        width: 14px;
        height: 14px;
    }

    .custom-select-switch {
        position: relative;
        background-color: #e1e1e1;
        width: 16px;
        height: 39px;
        border: 1px solid #bdbdbd;
        border-left: 0;
    }

    .custom-select-grid:hover .custom-select-switch{
        background-color: #e5effb;
        border-color: #4b6890;
    }

    .custom-select-grid:hover .custom-select{
        border-color: #828282;
    }

    .custom-select-dropdown {
        position: absolute;
        background-color: white;
        width: 334px;
        border: 1px solid #bdbdbd;
        border-top: 0;
        z-index: 10;
        max-height: 157px;
        overflow-y: auto;
    }

    .custom-select-option {
        padding: 10px;
        font-size: 14px;
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 20px;
        cursor: default;
    }

    .custom-select-option:hover {
        background-color: #2670d6;
        color: white;
    }

    .modal-checkbox-grid {
        display: grid;
        grid-template-columns: 25px max-content;
        margin: 25px 0;
    }

    .modal-checkbox-text {
        color: #939393;
        font-size: 14px;
    }

    .modal-checkbox {
        line-height: unset;
        position: relative;
        top: 9px;
        margin: 0;
    }

    .margin-20-0 {
        margin: 20px 0;
        font-size: 14px;
    }

</style>
